import React, { useState } from 'react';
import { apiRequest } from '../../api/index';
import ToastUtils from '../../utils/toast';

const ReportModal = ({ isOpen, onClose, userID, packages }) => {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [loading, setLoading] = useState(false);

  // Список месяцев на русском
  const months = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
  ];

  const handleDownloadCSV = async () => {
    if (!month || !year) {
      ToastUtils.error('Выберите месяц и год');
      return;
    }

    setLoading(true);
    try {
      
      // Формируем даты начала и конца месяца
      const monthNum = String(month).padStart(2, '0');
      const fromDateString = `${year}-${monthNum}-01T00:00:00Z`;
      // Вычисляем последний день месяца
      const nextMonth = new Date(Number(year), Number(month), 1);
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      const toDateString = `${nextMonth.getFullYear()}-${String(nextMonth.getMonth()).padStart(2, '0')}-01T00:00:00Z`;
      
      const params = new URLSearchParams();
      params.append('limit', '10000'); // Берем все лиды
      params.append('offset', '0');
      params.append('created_from', fromDateString);
      params.append('created_to', toDateString);
      
      const queryStr = params.toString();
      const loadedLeadsResponse = await apiRequest(`leads/${userID}/list?${queryStr}`, 'GET');
      const leads = loadedLeadsResponse.data.leads || [];
      
      if (leads.length === 0) {
        ToastUtils.error('Нет идентификаций за выбранный период');
        return;
      }
      
      // Формируем CSV
      const headers = ['ID', 'UUID', 'Телефон', 'Город', 'Регион', 'UTM Source', 'Дата создания', 'Поток', 'Пакет', 'Статус'];
      const rows = leads.map(lead => {
        const flowName = packages.find(f => f.id === lead.paket)?.flow_guide_name || '-';
        const paksName = packages.find(f => f.id === lead.paket)?.paks_name || '-';
        
        return [
          lead.id,
          lead.soda_id,
          lead.phone,
          lead.city_lead,
          lead.region_lead,
          lead.utm_source,
          new Date(lead.created_at).toLocaleDateString('ru-RU'),
          flowName,
          paksName,
          lead.status
        ].map(field => `"${field}"`).join(',');
      });

      const csvContent = [headers.join(','), ...rows].join('\n');
      const monthName = months[Number(month) - 1];
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `report_${monthName}_${year}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      ToastUtils.success('Отчет скачан');
      onClose();
    } catch (error) {
      console.error('Ошибка при скачивании отчета:', error);
      ToastUtils.error('Ошибка при скачивании отчета');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal small bottom-right open" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Формирование отчета</h3>
        </div>
        <div className="modal-body">
          <p>Выберите отчетный период: *</p>
          <div className="report-modal-inputs">
            <div className="report-input-group">
              <select
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                className="form-control"
              >
                <option value="">Выберите месяц</option>
                {months.map((monthName, index) => (
                  <option key={index} value={index + 1}>{monthName}</option>
                ))}
              </select>
            </div>
            <div className="report-input-group">
              <select
                value={year}
                onChange={(e) => setYear(e.target.value)}
                className="form-control"
              >
                <option value="">Выберите год</option>
                {Array.from({length: 10}, (_, i) => new Date().getFullYear() - 5 + i).map(y => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button 
            className="btn btn-primary-filled"
            onClick={handleDownloadCSV}
            disabled={loading}
          >
            {loading ? 'Скачивание...' : 'Скачать отчет CSV'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;
